import './header.css';

function Header() {
  return (
    <div className="header">
      <h1><span>See</span>SV</h1>
    </div>
  );
}

export default Header;